var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"width":230,"height":_vm.height}},'vue-content-loading',_vm.$attrs,false),[_vm._l((_vm.rows),function(i){return [_c('circle',{key:i + '_c',attrs:{"cx":"8","cy":_vm.getYPos(i, 8),"r":"8"}}),_vm._v(" "),_c('rect',{key:i + '_r',attrs:{"x":"22","y":_vm.getYPos(i, 3),"rx":"3","ry":"3","width":"200","height":"9"}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f52995","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/BulletList.vue
// module id = 24
// module chunks = 0 1